import request from './common/request'
import qs from 'qs'

import { SYSTEM_MERCHANT_ADMIN_URL } from './urls'

// 列表
async function list () {
  return request(
    {
      url: SYSTEM_MERCHANT_ADMIN_URL,
      method: 'GET'
    }
  )
}

// 插入
async function insert (data) {
  return request(
    {
      url: SYSTEM_MERCHANT_ADMIN_URL,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

// 更新
async function update (data) {
  return request(
    {
      url: `${SYSTEM_MERCHANT_ADMIN_URL}/${data.id}`,
      method: 'PUT',
      data: qs.stringify(data)
    }
  )
}

// 删除
async function remove (id) {
  return request(
    {
      url: `${SYSTEM_MERCHANT_ADMIN_URL}/${id}`,
      method: 'DELETE'
    }
  )
}

// 启用
async function enable (id) {
  return request(
    {
      url: `${SYSTEM_MERCHANT_ADMIN_URL}/${id}/enable`,
      method: 'PUT'
    }
  )
}

// 禁用
async function disable (id) {
  return request(
    {
      url: `${SYSTEM_MERCHANT_ADMIN_URL}/${id}/disable`,
      method: 'PUT'
    }
  )
}

async function resetPassword (id, password) {
  return request(
    {
      url: `${SYSTEM_MERCHANT_ADMIN_URL}/${id}/resetpwd`,
      method: 'PUT',
      data: qs.stringify({password})
    }
  )
}

// 获取管理员配置
async function getAdminSettings (id) {
  return request(
    {
      url: `${SYSTEM_MERCHANT_ADMIN_URL}/${id}/settings`,
      method: 'GET'
    }
  )
}

async function setAdminSettingValue (data) {
  return request(
    {
      url: `${SYSTEM_MERCHANT_ADMIN_URL}/${data.id}/settings`,
      method: 'PUT',
      data: qs.stringify(data)
    }
  )
}

// 商户管理员 - 详情
async function getMerchantDet (id) {
  return request(
    {
      url: `/merchant/system/admin/${id}`,
      method: 'GET'
    }
  )
}

export default {
  list,
  insert,
  update,
  remove,
  enable,
  disable,
  getMerchantDet,
  resetPassword,
  getAdminSettings,
  setAdminSettingValue
}



// WEBPACK FOOTER //
// ./src/api/merchant-admin.js